export default {
  subtitle: 'Wysyłamy wybrane zdarzenia do Twoich punktów końcowych, podpisane sekretem punktu końcowego.',
  regenerate_confirm: 'Wygenerować nowy sekret podpisujący? Obecny sekret przestanie działać natychmiast.',
  delete_confirm: 'Usunąć ten punkt końcowy? Przestanie otrzymywać zdarzenia.',
  consecutive_failures: '{{count}} kolejnych niepowodzeń',
  columns: {
    url: 'Punkt końcowy',
    events: 'Zdarzenia',
    status: 'Status',
    secret: 'Sekret',
  },
  statuses: {
    active: 'Aktywny',
    disabled: 'Wyłączony',
    auto_disabled: 'Automatycznie wyłączony',
  },
  buttons: {
    create: 'Dodaj punkt końcowy',
    edit: 'Edytuj',
    regenerate_secret: 'Nowy sekret',
    delete: 'Usuń',
  },
  toasts: {
    load_error: 'Nie udało się wczytać punktów końcowych webhooków.',
    error: 'Coś poszło nie tak. Spróbuj ponownie.',
    deleted: 'Punkt końcowy usunięty.',
  },
};
